import { useUserPermissions } from 'auth/hooks';
import { AccessPermissions } from 'core/enums';

export const useCanManageParts = (): boolean => {
  const { hasPermission } = useUserPermissions();

  return hasPermission(AccessPermissions.CORPORATE_PARTS);
};
